import { render, staticRenderFns } from "./waybill_mng_page.vue?vue&type=template&id=6774c862&scoped=true"
import script from "./waybill_mng_page.vue?vue&type=script&lang=js"
export * from "./waybill_mng_page.vue?vue&type=script&lang=js"
import style0 from "./waybill_mng_page.vue?vue&type=style&index=0&id=6774c862&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6774c862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6774c862')) {
      api.createRecord('6774c862', component.options)
    } else {
      api.reload('6774c862', component.options)
    }
    module.hot.accept("./waybill_mng_page.vue?vue&type=template&id=6774c862&scoped=true", function () {
      api.rerender('6774c862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/waybill/waybill_mng_page.vue"
export default component.exports